<div mat-dialog-content class="pb-3">
  <mat-accordion [multi]="true">
    <!-- TODO IMPROVEMENT: Create mediaCarouselComponent/mediaGridComponent and move the logic from here into those components -->
    <div class="flex flex-col h-full space-y-3">
      <app-expandable-section-box [isExpandable]="false">
        <div class="flex items-center justify-between flex-1" header>
          <span>Selected media</span>
          <span class="font-bold">Count {{ selectedMedias.length }}</span>
        </div>
        <div class="flex flex-1 w-full px-2 py-0" expandedContent>
          <div
            class="flex pt-2 space-x-3 overflow-x-auto min-h-[11.5rem]"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="drop($event)"
          >
            <ng-container *ngIf="selectedMedias?.length; else noMediasSelected">
              <app-media-thumbnail
                *ngFor="let selectedMedia of selectedMedias"
                [media]="selectedMedia"
                class="bg-white hover:cursor-pointer"
                cdkDrag
                data-testid="mediaAdderDialog-selectedMediaThumbnail"
                (click)="onToggleMediaSelection(selectedMedia)"
              >
                <mat-checkbox
                  class="absolute top-4 left-4"
                  [checked]="true"
                  data-testid="mediaAdderDialog-selectedMediaCheckbox"
                ></mat-checkbox>
              </app-media-thumbnail>
            </ng-container>
            <ng-template #noMediasSelected>
              <div
                class="flex items-center self-center justify-center px-5 py-4 border rounded border-project-1000 text-project-1000 bg-project-900"
              >
                <span class="brightness-75"> No media selected </span>
              </div>
            </ng-template>
          </div>
        </div>
      </app-expandable-section-box>

      <app-expandable-section-box
        [isExpandable]="false"
        [headerHeight]="'60px'"
        class="flex-1 h-3/5"
      >
        <form
          header
          [formGroup]="form"
          class="flex items-center justify-between flex-1 h-full font-sans"
          (keydown.enter)="$event.preventDefault()"
        >
          <div
            class="flex flex-1 px-2 py-0"
            data-testid="mediaAdderDialogSelectAll"
            id="mediaAdderDialogSelectAll"
          >
            <mat-checkbox
              *ngIf="canSelectMultiple"
              [formControl]="form.get(FORM_PATHS.SELECT_ALL())"
              (click)="onToggleSelectAll()"
              [checked]="form.get(FORM_PATHS.SELECT_ALL())"
              data-testid="mediaAdderDialog-selectAllCheckbox"
            >
              Select All
            </mat-checkbox>
          </div>
          <div class="flex space-x-2">
            <div
              *ngIf="mediaType === MEDIA_TYPES.IMAGE"
              class="flex px-2 py-0 pt-5"
            >
              <mat-checkbox
                *ngIf="!canSelectMultiple"
                class="hover:text-project-2100 hover:underline"
                color="primary"
                [formControl]="form.get(FORM_PATHS.SHOW_ARTICLE_READY_ONLY())"
                (click)="onToggleArticleReadyOnly()"
                data-testid="check-box-article-only"
              >
                Exclude images unsuitable for main image
              </mat-checkbox>
            </div>
            <div
              *ngIf="mediaType === MEDIA_TYPES.IMAGE"
              class="flex px-2 py-0 pt-5"
            >
              <mat-checkbox
                *ngIf="!canSelectMultiple"
                class="hover:text-project-2100 hover:underline"
                color="primary"
                [formControl]="form.get(FORM_PATHS.THREE_BY_ONE_FILTER())"
                (click)="onToggle3by1()"
                data-testid="checkbox-three-by-one"
              >
                Restrict to 3 x 1
              </mat-checkbox>
            </div>
            <div
              *ngIf="mediaType === MEDIA_TYPES.IMAGE"
              class="flex px-2 py-0"
              data-testid="mediaAdderDialog-searchTags"
              id="mediaAdderDialogSearchTags"
            >
              <mat-form-field
                [floatLabel]="'never'"
                class="w-80"
                appearance="outline"
              >
                <input
                  [formControl]="form.get(FORM_PATHS.SEARCH_TAGS_TERM())"
                  placeholder="Filter by tags..."
                  data-testid="mediaAdderDialogSearchTagsInput"
                  matInput
                  (keydown)="handleInput($event)"
                  [matAutocomplete]="tagsAutocomplete"
                />
                <mat-icon matSuffix class="pt-0.5 ml-2">filter_list</mat-icon>
                <mat-spinner
                  matSuffix
                  *ngIf="isSearchingTags"
                  [diameter]="15"
                  [strokeWidth]="3"
                ></mat-spinner>
                <mat-autocomplete
                  #tagsAutocomplete="matAutocomplete"
                  (optionSelected)="onTagSelected($event)"
                >
                  <ng-container *ngIf="tags$ | async as tags">
                    <ng-container
                      *ngIf="
                        tags?.length &&
                          !!form.get(FORM_PATHS.SEARCH_TAGS_TERM()).value &&
                          !isSearchingTags;
                        else noData
                      "
                    >
                      <ng-container *ngFor="let tag of tags">
                        <mat-option *ngIf="!isTagSelected(tag)" [value]="tag">
                          <div class="flex justify-between w-full space-x-4">
                            <button
                              class="overflow-hidden text-ellipsis whitespace-nowrap grow text-start"
                              data-testid="mediaAdderDialog-tagAutocompleteOptionText"
                              (click)="onTagClick(tag)"
                            >
                              {{ tag.text }}
                            </button>
                            <button
                              class="underline text-project-4400 hover:cursor-pointer hover:brightness-110"
                              data-testid="mediaAdderDialog-tagAutocompleteOptionPlus"
                              (click)="onAddTagClick(tag)"
                            >
                              [ + ]
                            </button>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #noData>
                    <mat-option
                      *ngIf="
                        !!form.get(FORM_PATHS.SEARCH_TAGS_TERM()).value &&
                        !isSearchingTags
                      "
                      disabled
                    >
                      No results
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div
              class="flex px-2 py-0"
              data-testid="mediaAdderDialogSearch"
              id="mediaAdderDialogSearch"
            >
              <mat-form-field
                [floatLabel]="'never'"
                class="w-80"
                appearance="outline"
              >
                <input
                  [formControl]="form.get(FORM_PATHS.SEARCH_TERM())"
                  placeholder="Search..."
                  data-testid="mediaAdderDialog-searchInput"
                  matInput
                  (keydown)="handleInput($event)"
                  (keydown.enter)="onSearch()"
                />
                <mat-icon
                  (click)="onSearch()"
                  matSuffix
                  class="pt-0.5 ml-2 cursor-pointer hover:text-project-2100"
                  >search</mat-icon
                >
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="flex flex-col flex-1 px-2 py-2" expandedContent>
          <div
            class="w-full px-4 py-3 mb-3 space-y-2 border rounded-md border-project-600"
            *ngIf="form.get(FORM_PATHS.SEARCH_TAGS()).value.length"
            data-testid="mediaAdderDialog-searchedTagsPanel"
          >
            <mat-label class="font-bold underline">Filtered tags</mat-label>
            <mat-chip-listbox aria-label="selectedTags">
              <mat-chip
                *ngFor="let tag of form.get(FORM_PATHS.SEARCH_TAGS()).value"
                (removed)="onRemoveTag(tag)"
                class="hover:bg-project-100"
              >
                {{ tag.text }}
                <button matChipRemove aria-label="removeTag">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-listbox>
          </div>
          <ng-container *ngIf="{ value: filteredMedias$ | async } as response">
            <app-processing-boundary
              [isProcessing]="isProcessing || !currentReponseItems"
              [processingMsg]="'Loading...'"
              class="flex flex-wrap h-full overflow-y-auto"
              [ngClass]="{
                'items-center justify-center':
                  isProcessing || !currentReponseItems,
                'items-start': !(isProcessing || !currentReponseItems)
              }"
            >
              <div
                *ngIf="response.value?.results.length; else noResults"
                class="flex flex-wrap items-center h-auto gap-4 overflow-y-auto justify-evenly"
              >
                <app-media-thumbnail
                  *ngFor="let media of response.value?.results"
                  data-testid="mediaAdderDialog-resultMediaThumbnail"
                  [media]="media"
                  [cmsUrl]="appConfig.cmsUrl"
                  class="hover:cursor-pointer"
                  (click)="onToggleMediaSelection(media)"
                >
                  <mat-checkbox
                    *ngIf="canSelectMultiple || isMediaSelected(media)"
                    class="absolute top-4 left-4"
                    [checked]="isMediaSelected(media)"
                    data-testid="mediaAdderDialog-resultMediaCheckbox"
                  ></mat-checkbox>
                </app-media-thumbnail>
              </div>
              <ng-template #noResults>
                <div
                  class="flex items-center self-center justify-center px-5 py-4 border rounded border-project-1000 text-project-1000 bg-project-900"
                >
                  <span class="brightness-75">
                    No results for the given search criteria
                  </span>
                </div>
              </ng-template>
            </app-processing-boundary>
            <app-pager
              class="-mx-6"
              *ngIf="response.value?.totalCount > 0 || currentTotalCount > 0"
              [pager]="pager"
              [dialogHeight]="true"
              [totalCount]="
                response.value?.totalCount ||
                (isProcessing && currentTotalCount)
              "
              (handlePageChange)="onPageChanged($event)"
              (handlePageSizeChange)="onPageSizeChanged($event)"
            ></app-pager>
          </ng-container>
        </div>
      </app-expandable-section-box>
    </div>
  </mat-accordion>
</div>

<div mat-dialog-actions>
  <div class="flex-1"></div>
  <button mat-button [mat-dialog-close]="{ actionResult: false, data: null }">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="{ actionResult: true, data: mapToMedia() }"
  >
    Done
  </button>
</div>
